<div class="overlay" *ngIf="isLoading | async">
	<div class="spinner">
		<div class="spinner-part spinner-part1"></div>
		<div class="spinner-part spinner-part2"></div>
		<img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
	</div>
</div>
<div class="user-profile">
	<div class="photo-section">
		<img [src]="newPhoto ? newPhoto : '/assets/images/user-profile.png'" alt="Profile Photo" class="profile-photo">
		<button type="button" (click)="openUploadPopup()" class="upload-button">Update photo</button>
	</div>
	<div class="field-section">
		<div class="d-flex justify-content-center">
			<form class="w-100" style="max-width: 900px;" [formGroup]="userForm">
				<div class="row">
					<div class="col-md-6 mb-3">
						<label for="employee">Employee ID</label>
						<input type="text" class="form-control" id="employeeId" placeholder="example" readonly
							formControlName="employeeId" [attr.value]="userForm.get('employeeId')?.value">
					</div>
					<div class="col-md-6 mb-3">
						<label for="firstName">First Name</label>
						<input type="text" class="form-control" id="firstName" placeholder="example" readonly
							formControlName="firstName" [attr.value]="userForm.get('firstName')?.value">
					</div>
					<div class="col-md-6 mb-3">
						<label for="lastName">Last Name</label>
						<input type="text" class="form-control" id="lastName" placeholder="example"
							formControlName="lastName" [attr.value]="userForm.get('lastName')?.value">
					</div>
					<div class="col-md-6 mb-3">
						<label for="dob">Date of Birth</label>
						<!-- <input type="date" class="form-control" id="dob" placeholder="example" formControlName="dob"> -->
						<input type="text" placeholder="Datepicker" class="form-control" formControlName="dob"
							[maxDate]="maxDate" [outsideClick]="true" bsDatepicker  [attr.value]="userForm.get('dob')?.value"
							[bsConfig]="{containerClass:'theme-dark-blue', showWeekNumbers:false, isAnimated: true, adaptivePosition: true, dateInputFormat: 'DD-MM-YYYY' }">
					</div>
					<div class="col-md-6 mb-3">
						<label for="email">Email ID</label>
						<input type="email" class="form-control" id="email" placeholder="example"
						[attr.value]="userForm.get('email')?.value"
							formControlName="email" readonly>
					</div>
					<div class="col-md-6 mb-3">
						<label for="mobile">Mobile Number</label>
						<input type="text" class="form-control" id="mobile" placeholder="example" maxlength="10"
						[attr.value]="userForm.get('mobileNumber')?.value"
							(keypress)="allowNumbersOnly($event)" formControlName="mobileNumber"
							[ngClass]="{ 'is-invalid': submitted && f['mobileNumber'].errors }">
						<div *ngIf="submitted && f['mobileNumber'].errors" class="invalid-feedback">
							<div *ngIf="f['mobileNumber'].errors['required']">
								Mobile number is required
							</div>
						</div>
					</div>
					<div class="col-md-6 mb-3">
						<label for="role">Role</label>
						<input type="text" class="form-control" id="role" placeholder="example" formControlName="role"
						[attr.value]="userForm.get('role')?.value"
							readonly>
					</div>
					<div class="col-md-6 mb-3">
						<label for="state">State</label>
						<select id="state" formControlName="state" class="form-control" (change)="getDistrict()"
						[attr.value]="userForm.get('state')?.value">
							<option value="" disabled selected>--Select State--</option>
							<option *ngFor="let state of stateList" [value]="state.id">{{
								state.state_name }}</option>
						</select>
					</div>
					<div class="col-md-6 mb-3">
						<label for="country">District</label>
						<select class="form-select" id="district" formControlName="district" (change)="getLocation()"
						[attr.value]="userForm.get('district')?.value">
							<option value="" disabled selected>--Select District--</option>
							<option *ngFor="let data of districtList" [value]="data.id">{{data.district_name}}</option>
						</select>
					</div>
					<div class="col-md-6 mb-3">
						<label for="city">Location</label>
						<select class="form-select" id="location" formControlName="location"
						[attr.value]="userForm.get('location')?.value">
							<option value="" disabled selected>--Select Location--</option>
							<option *ngFor="let data of locationList" [value]="data.id">{{data.location_name}}</option>
						</select>
					</div>
				</div>
				<div class="buttons">
					<button type="button" (click)="clearForm()">Clear</button>
					<button type="submit" (click)="onSubmit()">Save</button>
				</div>
			</form>
		</div>
	</div>
</div>

<!-- Upload Photo Popup -->
<div *ngIf="showUploadPopup" class="upload-popup">
	<div class="popup-content">
		<div class="popup-header">
			<h2>Add Profile Picture</h2>
			<button type="button" (click)="closeUploadPopup()" class="close-button">&times;</button>
		</div>
		<div class="popup-body">
			<div class="photo-drop-area" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
				(drop)="onDrop($event)">
				<div *ngIf="!newPhoto" class="default-image">
					<img src="/assets/images/frame.png" alt="">
					<p>Drag photo here</p>
				</div>
				<img *ngIf="newPhoto" [src]="newPhoto" alt="Selected Photo" class="selected-photo-img">
				<p *ngIf="!newPhoto">— Or —</p>
			</div>
			<div class="upload-options">
				<button *ngIf="!newPhoto" type="button" class="upload-button" (click)="triggerFileInput()"><img
						src="/assets/images/computer.png" alt=""> Upload from computer</button>
				<button *ngIf="newPhoto" type="button" class="upload-button" (click)="deletePicture()">Delete</button>
				<button *ngIf="newPhoto" type="button" class="upload-button" (click)="confirmPhoto()">Confirm</button>
			</div>
			<input type="file" #fileInput (click)="fileInput.value = ''" accept="image/*"
				(change)="onFileSelected($event)" hidden>
		</div>
	</div>
</div>